module.exports = __webpack_public_path__ + "static/media/Абушахмина Г.Р..068a5a64.pdf";